module.exports = __webpack_public_path__ + "img/receipt.4637216a.svg";